"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countingReducer = exports.CountingReducerActionType = void 0;
var CountingReducerActionType;
(function (CountingReducerActionType) {
    CountingReducerActionType[CountingReducerActionType["INCREASE"] = 0] = "INCREASE";
    CountingReducerActionType[CountingReducerActionType["DECREASE"] = 1] = "DECREASE";
    CountingReducerActionType[CountingReducerActionType["SET"] = 2] = "SET";
    CountingReducerActionType[CountingReducerActionType["RESET"] = 3] = "RESET";
})(CountingReducerActionType = exports.CountingReducerActionType || (exports.CountingReducerActionType = {}));
function countingReducer(state, action) {
    switch (action.type) {
        case CountingReducerActionType.DECREASE:
            return state - 1;
        case CountingReducerActionType.INCREASE:
            return state + 1;
        case CountingReducerActionType.RESET:
            return 0;
        case CountingReducerActionType.SET:
            return action.value;
        default:
            return state;
    }
}
exports.countingReducer = countingReducer;
//# sourceMappingURL=counting-reducer.js.map